export function BackToTop() {
    const backToTopLink = document.querySelector(".back-to-top_link");

    backToTopLink && backToTopLink.addEventListener('click', function(){
        window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
    })
  }
  